import { Link, useHistory } from 'react-router-dom';
import './App.css';
import ButtonActionDefault from './components/buttonAction';
import iconsIMG from './components/ImgImport';

function NotFound() {

  const history = useHistory()

  return (
    <div className="row m-0 justify-content-center">
      <div className="col-12 col-md-8 d-flex justify-content-between my-3">
        <Link to="/home">
          <img src={iconsIMG.LogoMei} height="50" />
        </Link>
      </div>

      <div className="col-12 col-md-8 d-flex flex-column justify-content-center mt-5 align-items-center" style={{ height: "60vh" }}>
        <p className="h1 font-weight-bold text-center">Página não encontrada!</p>
        <p className="h2 font-weight-bold text-center">Oops 😭</p>
        <p className="display-4 font-weight-bold text-center">404</p>
        <p className="h2 font-weight-bold text-center">Desculpe, a página que você solicitou não foi encontrada</p>

        <div className="d-flex justify-content-center mt-4">
          <ButtonActionDefault
            buttonData={{
              text: "Voltar à página principal",
              variant: "info",
              size: "lg",
              _class: "font-weight-bold",
              action: () => history.push("/home")
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default NotFound;
